import { CSSObject } from "@emotion/react";

import { navyBlue, navyBlueWithOpacity } from "@/angelouCE/utils/constants";

export const progressBarCss: CSSObject = {
  height: "6px",
  display: "flex",
  justifyContent: "space-between",
  listStyle: "none",
  margin: 0,
  padding: 0,
};

export const stepCss = (count: number, isComplete: boolean): CSSObject => ({
  height: "100%",
  backgroundColor: isComplete ? navyBlue : navyBlueWithOpacity,
  width: `${100 / count}%`,
  "&:not(:last-child)": {
    marginRight: "5px",
  },
});
